import axios, { AxiosHeaders } from "axios";

// const BASE_URL = "http://localhost:3000";

// const BASE_URL = "https://apicivilmantra.aimantra.info";

let BASE_URL = "https://dpr.aimantra.info";


//  BASE_URL = "https://ksncfd6v-8008.inc1.devtunnels.ms";

// const BASE_URL_PREBID = "https://cipl.aimantra.info";
const BASE_URL_PREBID = "https://staging.aimantra.info";
let IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
// const BASE_URL_PREBID = "https://lr2gx6jv-8001.inc1.devtunnels.ms";

// const BASE_URL_PREBID = "http://localhost:8000";

const currentUrl = window.location.href;
const urlParts = currentUrl.split("/");
const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];

export const AUTH = () => ({
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

export const AUTHH = () => ({
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
  },
});

// ─────────────────────────────────────────────────────────────
//  Global authentication for every portal API call
//  - Adds the latest Bearer token to every request to our backend
//  - Login / forgot / reset password stay public
//  - FormData uploads: drops Content-Type so the browser sets the boundary
//  - 401 from backend → clear session and go to /login
// ─────────────────────────────────────────────────────────────
const PUBLIC_ENDPOINTS = [
  "/user/login/",
  "/user/forgotpassword/",
  "/user/forgotpasswordchange/",
];

const API_ORIGINS = [BASE_URL, BASE_URL_PREBID].map((u) => u.replace(/\/+$/, ""));

const resolveUrl = (config) => {
  const url = config.url || "";
  if (/^https?:\/\//i.test(url) || !config.baseURL) return url;
  return config.baseURL.replace(/\/+$/, "") + "/" + url.replace(/^\/+/, "");
};

const isOurApi = (url) => API_ORIGINS.some((origin) => url.startsWith(origin + "/"));
const isPublic = (url) => PUBLIC_ENDPOINTS.some((path) => url.includes(path));

axios.interceptors.request.use((config) => {
  const url = resolveUrl(config);
  if (!isOurApi(url)) return config;

  config.headers = AxiosHeaders.from(config.headers);

  if (typeof FormData !== "undefined" && config.data instanceof FormData) {
    config.headers.delete("Content-Type");
  }

  if (isPublic(url)) return config;

  const token = sessionStorage.getItem("access_token");
  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  } else {
    config.headers.delete("Authorization");
  }
  return config;
});

let redirectingToLogin = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config ? resolveUrl(error.config) : "";
    if (status === 401 && isOurApi(url) && !isPublic(url) && !redirectingToLogin) {
      redirectingToLogin = true;
      sessionStorage.clear();
      window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

export { BASE_URL, BASE_URL_PREBID, FRONTEND_URL, IMAGE_URL };
export default axios;